export default {
  GET_USER_TYPE: (state) => state.user_type,
};
